import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { type AppState, type AppDispatch } from 'src/redux/app/app.store'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector
